// extracted by mini-css-extract-plugin
export default {"productGrid":"s1-z","centerLink":"t1-z","productSection":"u1-z","item":"v1-z","ctaButton":"w1-z"};